"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgUserSearch = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M9.166 11.12A5.003 5.003 0 017 7a5 5 0 119.842 1.247 7.008 7.008 0 00-2.014-.245 3 3 0 10-4.304 1.61c-.522.433-.98.941-1.358 1.507zM8.063 14h-.059C4.001 14 2 16 2 20c0 1.333.667 2 2 2h10.992a6.977 6.977 0 01-4.899-2H4c0-2.667 1.333-4 4-4h.063a7.06 7.06 0 010-2z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M14.992 10a5 5 0 014.178 7.747l.096.096 2.482 2.492c.393.447.243 1.013-.087 1.342-.33.328-.896.469-1.316.054l-.043-.043-2.533-2.53A5 5 0 1114.992 10zm-3 5a3 3 0 116 0 3 3 0 01-6 0z' }))); };
exports.default = SvgUserSearch;
//# sourceMappingURL=UserSearch.js.map